module.exports = __webpack_public_path__ + "static/media/hugging-face-svgrepo-com.5d89b3ac.svg";